import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CalendarOptions, EventInput } from '@fullcalendar/core';
import { FullCalendarComponent } from '@fullcalendar/angular';

import dayjs from 'dayjs';

@Component({
    selector: 'app-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['./timeline.component.less'],
})
export class TimelineComponent implements OnInit, OnChanges {
    @ViewChild('fullCalendar') fullCalendar!: FullCalendarComponent;
    @Input() resources: EventInput[] = [];
    @Input() events: EventInput[] = [];
    @Input() resourceAreaHeaderContent = 'Name';
    @Input() isClickedRow = false;
    @Input() leftToolbar = 'prev,next';
    @Input() rightToolbar = 'resourceTimelineWeek,resourceTimelineMonth,resourceTimelineYear';
    @Input() initialView = 'resourceTimelineMonth';
    @Output() clickResource = new EventEmitter();
    @Output() changeRange = new EventEmitter();
    calendarOptions: CalendarOptions & { resources: any[], resourceAreaWidth: any, resourceOrder: any, resourceAreaHeaderContent: any, resourceLabelDidMount: any } = {
        height: '100%',
        schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
        timeZone: 'UTC',
        resources: [],
        editable: true,
        selectable: true,
        aspectRatio: 1.5,
        handleWindowResize: true,
        initialView: this.initialView,
        resourceAreaWidth: '180px',
        resourceOrder: 'default',
        headerToolbar: {
            left: this.leftToolbar,
            center: 'title',
            right: this.rightToolbar,
        },
        views: {
            resourceTimelineWeek: {
                type: 'resourceTimeline',
                buttonText: 'Week',
            },
            resourceTimelineMonth: {
                type: 'resourceTimeline',
                buttonText: 'Month',
            },
            resourceTimelineYear: {
                type: 'resourceTimeline',
                buttonText: 'Year',
            },
        },
        resourceAreaHeaderContent: 'Name',
        resourceLabelDidMount: (info: any) => {
            info.el.onclick = () => {
                this.clickResource.emit(info.resource._resource);
            };
        },
        events: [],
        datesSet: (val) => {
            console.log('datesSet', val);
            const {
                startStr,
                endStr
            } = val;
            const range = [dayjs(startStr).format('YYYY-MM-DD'), dayjs(endStr).format('YYYY-MM-DD')];
            this.changeRange.emit(range);
        },
    };

    constructor() {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.resetOptions();
    }

    resetOptions(): void {
        console.log('timeline', this.resources);
        this.calendarOptions = {
            ...this.calendarOptions,
            events: [...this.events],
            resources: [...this.resources],
            initialView: this.initialView,
            headerToolbar: {
                ...this.calendarOptions.headerToolbar,
                left: this.leftToolbar,
                right: this.rightToolbar
            },
        };
        console.log('reset', this.calendarOptions);
    }

    getDateRange(date: any): void {
        const { startDate, endDate } = date;
        const startDay = dayjs(startDate).format('YYYY-MM-DD');
        const endDay = dayjs(endDate).format('YYYY-MM-DD');
        const diffYear = dayjs(endDay).year() - dayjs(startDay).year() + 1;
        const diffWeek = dayjs(endDay).diff(dayjs(startDay), 'week') + 1;
        const diffMonth = (dayjs(endDay).year() - dayjs(startDay).year()) * 12 + dayjs(endDay).month() - dayjs(startDay).month() + 1;
        console.log('diff', diffWeek, diffMonth, diffYear);
        this.calendarOptions!.views!.resourceTimelineYear!.duration = {
            years: diffYear,
        };
        this.calendarOptions!.views!.resourceTimelineWeek!.duration = {
            days: diffWeek * 7,
        };
        this.calendarOptions!.views!.resourceTimelineMonth!.duration = {
            months: diffMonth,
        };
        console.log(this.calendarOptions);
    }

    setStartDate(date: { startDate: string, endDate: string }): void {
        console.log(date);
        const calendarApi = this.fullCalendar.getApi();
        if (calendarApi) {
            calendarApi.gotoDate(dayjs(date.startDate).format('YYYY-MM-DD'));
            this.getDateRange(date);
        }
    }

    formatDate(date: Date, time: Date): string {
        return dayjs(date).format('YYYY-MM-DD') + ' ' + dayjs(time).format('HH:mm:ss');
    }
}
